/**
 * countdown-lite.js — Hafif countdown timer (~1.5 KB)
 * countdown.js (199 KB) yerine vanilla JS alternatif
 * Aynı selector, attribute ve HTML output formatını kullanır
 */
(function() {
  'use strict';

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function updateCountdown(el) {
    var promoperiod;
    var attrPeriod = el.getAttribute('data-promoperiod');
    var attrCountdown = el.getAttribute('data-countdown');

    if (attrPeriod) {
      promoperiod = Date.now() + parseInt(attrPeriod, 10);
    } else if (attrCountdown) {
      promoperiod = new Date(attrCountdown).getTime();
    }

    if (!promoperiod || isNaN(promoperiod)) return false;

    var diff = promoperiod - Date.now();

    if (diff <= 0) {
      el.parentElement && (el.parentElement.style.display = 'none');
      return false;
    }

    el.classList.add('countdown-block');

    var d = Math.floor(diff / 86400000);
    var h = Math.floor((diff % 86400000) / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);

    el.innerHTML =
      '<span><span>' + pad(d) + '</span><span class="dots"> : </span></span>' +
      '<span><span>' + pad(h) + '</span><span class="dots"> : </span></span>' +
      '<span><span>' + pad(m) + '</span><span class="dots"> : </span></span>' +
      '<span><span class="second">' + pad(s) + '</span></span>';

    return true;
  }

  function initCountdowns(selector) {
    var elements = document.querySelectorAll(selector || '.flip-countdown, .js-flip-countdown');
    if (!elements.length) return;

    function tick() {
      var alive = false;
      for (var i = 0; i < elements.length; i++) {
        if (updateCountdown(elements[i])) alive = true;
      }
      if (alive) setTimeout(tick, 1000);
    }
    tick();
  }

  // jQuery plugin uyumluluğu — countDownIni() fonksiyonu custom.js'ten çağırır
  window.countdownLiteInit = initCountdowns;

  // Sayfa yüklendiğinde otomatik başlat
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initCountdowns(); });
  } else {
    initCountdowns();
  }
})();
